var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.disabled
        ? _c(
            "b-alert",
            { staticClass: "mb-1", attrs: { variant: "warning", show: "" } },
            [
              _c("div", { staticClass: "alert-body" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "A cobrança por KM não usa faixas de taxa. Limpe as faixas para salvar (I11)."
                      )
                    ) +
                    " "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("FormulateInput", {
        attrs: {
          name: _vm.name,
          type: "group",
          "error-behavior": "live",
          repeatable: !_vm.disabled,
          "add-label": _vm.$t("Adicionar faixa de taxa"),
          minimum: 0,
          disabled: _vm.disabled,
          label: _vm.label,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var index = ref.index
              return [
                _vm.internalTiers[index]
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: _vm.name + "-from-" + index,
                                type: "text-number",
                                filter: "currency",
                                currency: "R$",
                                precision: 2,
                                name: "productsValueFrom",
                                validation: "required|min:0",
                                disabled: _vm.disabled,
                                label: _vm.$t("A partir de"),
                              },
                              model: {
                                value:
                                  _vm.internalTiers[index].productsValueFrom,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.internalTiers[index],
                                    "productsValueFrom",
                                    $$v
                                  )
                                },
                                expression:
                                  "internalTiers[index].productsValueFrom",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c("FormulateInput", {
                              staticClass: "required",
                              attrs: {
                                id: _vm.name + "-value-" + index,
                                type: "text-number",
                                filter: "currency",
                                currency: "R$",
                                precision: 2,
                                name: "value",
                                validation: "required|min:0",
                                disabled:
                                  _vm.disabled || _vm.isFreeShipping(index),
                                label: _vm.$t("Valor"),
                              },
                              model: {
                                value: _vm.internalTiers[index].value,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.internalTiers[index],
                                    "value",
                                    $$v
                                  )
                                },
                                expression: "internalTiers[index].value",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex align-items-center",
                            attrs: { md: "4" },
                          },
                          [
                            _c(
                              "b-form-checkbox",
                              {
                                attrs: {
                                  id: _vm.name + "-free-" + index,
                                  switch: "",
                                  checked: _vm.isFreeShipping(index),
                                  disabled: _vm.disabled,
                                },
                                on: {
                                  change: function (checked) {
                                    return _vm.toggleFreeShipping(
                                      index,
                                      checked
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("Frete grátis nesta faixa")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
        model: {
          value: _vm.internalTiers,
          callback: function ($$v) {
            _vm.internalTiers = $$v
          },
          expression: "internalTiers",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }